import { Icon } from "@app/icons";
import { useSeason } from "@app/workspace";
import { Menu, Tooltip } from "@mantine/core";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

/** The working season on a page that uses it: a chip next to the title that switches the year in place (every
 *  year-dependent page follows that one year, like the legacy client's opened Data<year>.mdb). Opening or removing a
 *  year stays on the top bar's year button. */
export function SeasonChip() {
  const { t } = useTranslation();
  const { ev } = useSeason();
  const [open, setOpen] = useState(false);
  if (!ev) return null;
  return (
    <Menu opened={open} onChange={setOpen} position="bottom-start" withinPortal>
      <Tooltip label={t("shell.yearHelp")} disabled={open}>
        <Menu.Target>
          <button type="button" className="chip g" aria-label={`${ev} · ${t("shell.switchYear")}`}>
            <span className="mono">{ev}</span>
            <Icon name="chevronDown" size={12} />
          </button>
        </Menu.Target>
      </Tooltip>
      <SeasonMenuDropdown />
    </Menu>
  );
}

/** The season menu's years; ``children`` (the top bar's year button: opening and removing a year) come after them. */
export function SeasonMenuDropdown({ children }: { children?: ReactNode }) {
  const { ev, years, setEv } = useSeason();
  return (
    <Menu.Dropdown mah={360} style={{ overflowY: "auto" }}>
      {years.map((y) => (
        <Menu.Item key={y} onClick={() => setEv(y)} fw={y === ev ? 700 : 400} className="mono">
          {y}
        </Menu.Item>
      ))}
      {children}
    </Menu.Dropdown>
  );
}
